export const billing = {
aiUsageAudit: {
title: "تدقيق الذكاء الاصطناعي والأتمتة لمساحة العمل",
loading: "جارٍ تحميل سجل التدقيق...",
empty: "لا توجد أحداث تدقيق حتى الآن.",
intro: "سجل تدقيق لعمليات الذكاء الاصطناعي والأتمتة في مساحة العمل هذه. يعرض آخر 200 حدث مع بيانات القدرة والتتبع والاستخدام والرصيد عند توفرها.",
refresh: "تحديث",
refreshing: "جارٍ التحديث...",
noAccount: "لم يتم العثور على حساب مساحة عمل لهذا الملف الشخصي.",
loadFailed: "فشل تحميل أحداث التدقيق.",
service: "الخدمة:",
status: "الحالة:",
filters: {
all: "الكل",
success: "ناجح",
error: "خطأ",
ai: "الذكاء الاصطناعي",
automation: "الأتمتة",
},
totalCredits: "إجمالي أرصدة الذكاء الاصطناعي (المُصفّاة):",
totalShown: "الإجمالي المعروض:",
creditUnitsLogged: "وحدات الرصيد المسجّلة (الذكاء الاصطناعي + الأتمتة، الأحداث المعروضة):",
noEventsFiltered: "لا توجد أحداث مطابقة للمرشحات المحددة.",
memberTitle: "استخدام الذكاء الاصطناعي",
memberSubtitle: "يتشارك جميع أعضاء مساحة العمل أرصدة الذكاء الاصطناعي.",
memberBody: "يراجع مالك مساحة العمل استخدام الذكاء الاصطناعي فيها. رصيد الأرصدة المشترك موجود في الفوترة والاستخدام.",
},
usage: {
addons: {
  title: "الإضافات",
  subtitle: "ميزات إضافية لخطتك، تُدفع لكل أصل.",
  loadFailed: "تعذر تحميل الإضافات. حاول لاحقاً.",
  perAssetMonth: "{{price}} لكل أصل شهرياً",
  included: "مضمّنة في خطتك",
  statusTrialing: "مفعّلة: تجربة مجانية حتى {{date}}",
  statusActive_zero: "مفعّلة لـ {{count}} أصل: {{total}} شهرياً",
  statusActive_one: "مفعّلة لـ {{count}} أصل: {{total}} شهرياً",
  statusActive_two: "مفعّلة لـ {{count}} أصل: {{total}} شهرياً",
  statusActive_few: "مفعّلة لـ {{count}} أصل: {{total}} شهرياً",
  statusActive_many: "مفعّلة لـ {{count}} أصل: {{total}} شهرياً",
  statusActive_other: "مفعّلة لـ {{count}} أصل: {{total}} شهرياً",
  statusActiveNoPrice_zero: "مفعّلة لـ {{count}} أصل",
  statusActiveNoPrice_one: "مفعّلة لـ {{count}} أصل",
  statusActiveNoPrice_two: "مفعّلة لـ {{count}} أصل",
  statusActiveNoPrice_few: "مفعّلة لـ {{count}} أصل",
  statusActiveNoPrice_many: "مفعّلة لـ {{count}} أصل",
  statusActiveNoPrice_other: "مفعّلة لـ {{count}} أصل",
  statusOff: "متوقفة",
  notOnPlan: "غير متاحة في خطتك. غيّر خطتك لإضافتها (تعرض الخطط أيها يتيحها).",
  notAvailableInApp: "غير متاحة للشراء داخل التطبيق",
  adminsOnly: "يضيف مسؤولو مساحة العمل الإضافات أو يوقفونها.",
  coverTitle: "ما تغطيه",
  coverWhole: "مساحة العمل كلها",
  coverSites: "مواقع مختارة",
  coverHint: "الموقع المختار يغطي أيضاً المواقع التي بداخله.",
  noSites: "لا توجد مواقع بعد: تغطي مساحة العمل كلها.",
  liveTotal_zero: "{{count}} أصل × {{price}} = {{total}} شهرياً",
  liveTotal_one: "{{count}} أصل × {{price}} = {{total}} شهرياً",
  liveTotal_two: "{{count}} أصل × {{price}} = {{total}} شهرياً",
  liveTotal_few: "{{count}} أصل × {{price}} = {{total}} شهرياً",
  liveTotal_many: "{{count}} أصل × {{price}} = {{total}} شهرياً",
  liveTotal_other: "{{count}} أصل × {{price}} = {{total}} شهرياً",
  trialNote: "مجانية لمدة {{days}} يوماً، ثم تُفوتر مع خطتك. يمكنك إيقافها في أي وقت.",
  proRata: "تسري التغييرات اليوم وتُحتسب أو تُرد بالتناسب في فاتورتك القادمة.",
  startTrial: "ابدأ تجربة مجانية لمدة {{days}} يوماً",
  startPaid: "أضف إلى خطتي",
  save: "احفظ التغطية",
  end: "إيقاف",
  keep: "إبقاء",
  endConfirmTitle: "إيقاف {{name}}؟",
  endConfirmBody: "تنتهي اليوم ويُرد الوقت المدفوع غير المستخدم في فاتورتك القادمة. تبقى بيانات ESG محفوظة وتعود إذا فعّلتها مجدداً.",
  chooseSite: "اختر موقعاً واحداً على الأقل، أو مساحة العمل كلها.",
  failed: "تعذر تحديث الإضافة. حاول مرة أخرى.",
},
  assistantGate: {
    debitFailedMember: "تعذّر على المساعد استخدام الأرصدة لهذا الطلب. حاول مرة أخرى بعد قليل.",
    debitFailedAdmin: "تعذّر على المساعد استخدام الأرصدة لهذا الطلب. حاول مرة أخرى، أو راجع الفوترة والاستخدام إذا تكرر ذلك.",
    debitFailedTitle: "تعذّر استخدام الأرصدة",
    disabledAdmin: "الذكاء الاصطناعي غير مضمّن في خطة مساحة العمل هذه. افتح الفوترة والاستخدام لرؤية الخطط التي تتضمنه.",
    disabledMemberUnnamed: "الذكاء الاصطناعي غير مضمّن في خطة مساحة العمل هذه. اسأل مالك مساحة العمل عن الخطة.",
    disabledMember: "الذكاء الاصطناعي غير مضمّن في خطة مساحة العمل هذه. اسأل {{owner}} عن الخطة.",
    disabledTitle: "مساعد الذكاء الاصطناعي متوقف",
  },
  assetGate: {
    seePlans: "عرض الخطط",
    subscriptionRequired: "استخدمت مساحة عملك الأصول المجانية في خطتها. ابدأ اشتراكًا لإضافة المزيد من الأصول.",
    askOwner: "اطلب من مالك مساحة العمل إضافة خطة قبل إضافة المزيد من الأصول.",
    askOwnerNamed: "اطلب من مالك {{workspace}} إضافة خطة قبل إضافة المزيد من الأصول.",
    title: "الاشتراك مطلوب",
  },
  checkout: {
    unavailable: "الشراء غير متاح حاليًا. حاول لاحقًا.",
    needsEmail: "أضف بريدًا إلكترونيًا إلى ملفك الشخصي قبل بدء الدفع.",
    contactSales: "يبيع فريقنا هذه الخطة. تواصل مع AssetWRX للبدء.",
    notConfigured: "هذه الخطة غير متاحة للشراء بعد. تواصل مع الدعم.",
    generic: "تعذّر بدء الدفع. حاول مرة أخرى بعد قليل، أو تواصل مع الدعم إذا تكرر ذلك.",
  },
  store: {
    planGone: "لم تعد هذه الخطة معروضة. أغلق هذه الشاشة وافتحها مجددًا.",
    unavailable: "عمليات الشراء من المتجر غير متاحة في هذا الإصدار من التطبيق.",
    purchaseFailed: "لم تكتمل عملية الشراء. حاول مرة أخرى.",
    ownerOnly: "لا يستطيع إدارة اشتراك المتجر إلا مالك مساحة العمل.",
  },
  workAi: {
    hostFallback: "مساحة العمل",
    settingTitle: "الذكاء الاصطناعي للأشخاص الذين تعمل معهم",
    settingSubtitle: "يمكن للمقاولين ومقدّمي الطلبات استخدام الذكاء الاصطناعي في مهامك وفحوصاتك وأصولك، ويُدفع من أرصدتك.",
    settingLabel: "الأرصدة شهريًا لكل شخص",
    settingHelper: "اتركه فارغًا للحصة القياسية. القيمة 0 توقفه.",
    settingPlaceholder: "قياسي",
    settingInvalid: "أدخل عددًا صحيحًا أو اتركه فارغًا.",
    settingSave: "حفظ",
    settingSaved: "تم الحفظ",
    settingFailed: "تعذّر حفظ الحصة",
    usedTitle: "استُنفد الذكاء الاصطناعي المقدَّم من {{host}} لهذا الشهر",
    offTitle: "لا يقدّم {{host}} الذكاء الاصطناعي على أعماله",
    useOwnBody: "يمكنك استخدام أرصدة الذكاء الاصطناعي الخاصة بك بدلًا من ذلك.",
    notNow: "ليس الآن",
    useOwn: "استخدام أرصدتي",
    refused: "استُنفد الذكاء الاصطناعي المقدَّم من {{host}} لهذا الشهر.",
  },
  aiGate: {
    freePeriodEnded: "الذكاء الاصطناعي متوقف مؤقتًا لأن الفترة المجانية انتهت ومساحة العمل هذه للقراءة فقط.",
    pastDue: "الذكاء الاصطناعي متوقف مؤقتًا بسبب فشل في الدفع. حدّث الفوترة لإعادة تشغيله.",
    canceled: "الذكاء الاصطناعي متوقف لأن اشتراك مساحة العمل هذه أُلغي.",
    notEnoughCredits_other: "يحتاج هذا إلى {{count}} من أرصدة الذكاء الاصطناعي ولا تملك مساحة عملك ما يكفي.",
    notEnoughCredits_many: "يحتاج هذا إلى {{count}} رصيد ذكاء اصطناعي ولا تملك مساحة عملك ما يكفي.",
    notEnoughCredits_few: "يحتاج هذا إلى {{count}} أرصدة ذكاء اصطناعي ولا تملك مساحة عملك ما يكفي.",
    notEnoughCredits_two: "يحتاج هذا إلى رصيدي ذكاء اصطناعي ولا تملك مساحة عملك ما يكفي.",
    notEnoughCredits_one: "يحتاج هذا إلى رصيد ذكاء اصطناعي واحد ولا تملك مساحة عملك ما يكفي.",
    notEnoughCredits_zero: "لا تملك مساحة عملك أرصدة ذكاء اصطناعي كافية لهذا.",
    readOnly: "الذكاء الاصطناعي متوقف مؤقتًا لأن مساحة العمل هذه للقراءة فقط.",
    notInPlan: "الذكاء الاصطناعي غير مضمّن في خطة مساحة العمل هذه.",
    checkFailed: "تعذّر التحقق من أرصدة الذكاء الاصطناعي. حاول مرة أخرى.",
  },
  creditCode: {
    refund: "استرداد",
    adjustment: "تعديل",
    included: "الأرصدة المضمّنة",
    purchase: "شراء",
    topUp: "شحن الرصيد",
    aiCredits: "أرصدة الذكاء الاصطناعي",
    aiUsage: "استخدام الذكاء الاصطناعي",
  },
  packCredits_other: "{{count}} رصيد",
  packCredits_many: "{{count}} رصيدًا",
  packCredits_few: "{{count}} أرصدة",
  packCredits_two: "رصيدان",
  packCredits_one: "رصيد واحد",
  packCredits_zero: "لا أرصدة",
  planLoadFailed: "تعذّر تحميل خطتك.",
  ownerManagesUnnamed: "يدير مالك مساحة العمل الخطة والأرصدة لمساحة العمل هذه.",
  ownerManages: "يدير {{owner}} الخطة والأرصدة لمساحة العمل هذه.",
  confirmationAwaitingBody: "أكمل الدفع في نافذة الدفع ثم عد إلى هنا. اضغط تحديث إن لم تُحدَّث خطتك وأرصدتك.",
  confirmationAwaitingTitle: "بانتظار إتمام الدفع",
  paymentStatusInactiveDetailMember: "لا يوجد اشتراك نشط. يمكن لمالك مساحة العمل بدء اشتراك.",
  paymentStatusPausedDetailMember: "الاشتراك متوقف مؤقتًا. يمكن لمالك مساحة العمل استئنافه.",
  paymentStatusPastDueDetailMember: "هناك دفعة متأخرة. يمكن لمالك مساحة العمل معالجتها في الفوترة والاستخدام.",
  statusFreePeriodEndedMember: "انتهت الفترة المجانية وأصبحت مساحة العمل للقراءة فقط. يمكن للمالك اختيار خطة؛ لم يُحذف أي شيء.",
  statusFreeLimitReachedMember: "تم بلوغ الحد المجاني. يمكن لمالك مساحة العمل اختيار خطة لإضافة المزيد من الأصول.",
  statusFreeUntilMember: "مجاني حتى {{date}}. يختار مالك مساحة العمل الخطة.",
  statusFreeFirstAsset_other: "تتضمن خطتك {{count}} أصل مجاني. تبدأ الفوترة عند إضافة المزيد.",
  statusFreeFirstAsset_many: "تتضمن خطتك {{count}} أصلًا مجانيًا. تبدأ الفوترة عند إضافة المزيد.",
  statusFreeFirstAsset_few: "تتضمن خطتك {{count}} أصول مجانية. تبدأ الفوترة عند إضافة المزيد.",
  statusFreeFirstAsset_two: "تتضمن خطتك أصلين مجانيين. تبدأ الفوترة عند إضافة المزيد.",
  statusFreeFirstAsset_one: "تتضمن خطتك أصلًا مجانيًا واحدًا. تبدأ الفوترة عند إضافة الأصل التالي.",
  statusFreeFirstAsset_zero: "لا تتضمن خطتك أصولًا مجانية. تبدأ الفوترة مع أول أصل.",
  creditsNeeded_other: "يحتاج هذا إلى {{count}} رصيد ولديك {{balance}}.",
  creditsNeeded_many: "يحتاج هذا إلى {{count}} رصيدًا ولديك {{balance}}.",
  creditsNeeded_few: "يحتاج هذا إلى {{count}} أرصدة ولديك {{balance}}.",
  creditsNeeded_two: "يحتاج هذا إلى رصيدين ولديك {{balance}}.",
  creditsNeeded_one: "يحتاج هذا إلى رصيد واحد ولديك {{balance}}.",
  creditsNeeded_zero: "لا يحتاج هذا إلى أرصدة ولديك {{balance}}.",
  continueWithoutAi: "المتابعة دون الذكاء الاصطناعي",
  outOfCreditsOk: "حسنًا",
  outOfCreditsNeutral: "نفدت أرصدة الذكاء الاصطناعي في مساحة عملك. يمكنك مواصلة العمل دون الذكاء الاصطناعي.",
  outOfCreditsMemberBodyUnnamed: "يمكنك مواصلة العمل دون الذكاء الاصطناعي. اطلب من مالك مساحة العمل إضافة أرصدة.",
  outOfCreditsMemberBody: "يمكنك مواصلة العمل دون الذكاء الاصطناعي. اطلب من {{owner}} إضافة أرصدة.",
  outOfCreditsAdminBodyNoBuy: "يمكنك مواصلة العمل دون الذكاء الاصطناعي.",
  outOfCreditsAdminBody: "يمكنك مواصلة العمل دون الذكاء الاصطناعي، أو شراء باقة أرصدة.",
title: "الفوترة والاستخدام",
intro: "راجع حالة الاشتراك والأرصدة وإجراءات الفوترة التالية.",
summaryIntro: "خطتك وأرصدتك وفوترتك.",
outOfCreditsTitle: "نفدت أرصدة الذكاء الاصطناعي",
outOfCreditsBody: "تحتاج إجراءات الذكاء الاصطناعي إلى أرصدة. اشترِ حزمة أرصدة للمتابعة، أو انتظر أرصدتك الشهرية المضمّنة.",
outOfCreditsNotNow: "ليس الآن",
trialCapTitle: "تجاوزت حد النسخة التجريبية",
creditPackPickerTitle: "اختر باقة أرصدة",
creditPackPickerSubtitle: "الأرصدة لا تنتهي صلاحيتها أبدًا.",
buyCreditsCta: "شراء",
cancel: "إلغاء",
kpiSectionTitle: "لقطة الاستخدام",
kpiSectionHint: "ما تُفوتر عليه، ورصيد الذكاء الاصطناعي المتاح لك.",
kpiAssetsTitle: "الأصول القابلة للفوترة",
kpiAssetsBody: "الأصول النشطة المفوترة في هذه الدورة.",
kpiMonthlyPlanTitle: "أرصدة الخطة",
kpiMonthlyPlanBody: "الأرصدة المضمّنة كل شهر.",
kpiMonthlyPlanBodyUnlimited: "الأرصدة الشهرية غير محدودة.",
kpiPurchasedTitle: "الأرصدة المشتراة",
kpiPurchasedBody: "أرصدة الشحن المتبقية.",
kpiRemainingTitle: "الأرصدة المتبقية",
kpiRemainingBody: "الأرصدة المضمّنة + المشتراة المتبقية.",
kpiRemainingBodyUnlimited: "الأرصدة غير محدودة لمساحة العمل هذه.",
loading: "جارٍ تحميل الفوترة...",
refresh: "تحديث",
refreshing: "جارٍ التحديث...",
noAccount: "لم يتم العثور على حساب مساحة عمل لهذا الملف الشخصي.",
loadFailed: "فشل تحميل بيانات الفوترة.",
billingDataMissing: "تعذّر عرض بيانات الفوترة. حاول التحديث.",
errorTitle: "بيانات الفوترة غير متاحة",
emptyTitle: "الفوترة تحتاج إلى مساحة عمل",
emptyBody: "الفوترة تخص مساحة عمل. انتقل إلى مساحة عمل لترى خطتها وأرصدتها وعملة فاتورتها.",
planTitle: "الاشتراك",
unlimited: "غير محدود",
subscriptionSummaryTitle: "ملخص الاشتراك",
subscriptionSummarySubtitle: "الحالة الموثقة من المزوّد وتوقيت التجديد لمساحة العمل هذه.",
managedOnWeb: "لا تتوفر تغييرات الخطة والأرصدة في هذا التطبيق.",
statusFreeUntil: "مجاني حتى {{date}}. اختر خطة ليستمر عمل مساحة العمل بعد ذلك.",
internalEditionName: "Developer (إصدار اختبار داخلي)",
statusInternalEdition: "إصدار اختبار داخلي: كل الميزات مفعّلة ولا تُحتسب أي رسوم. يُضبط من لوحة الإدارة فقط.",
statusGranted: "خطتك مقدَّمة دون رسوم، بلا تاريخ انتهاء.",
statusGrantedUntil: "خطتك مقدَّمة دون رسوم حتى {{date}}. اختر خطة قبل ذلك ليستمر عمل مساحة العمل.",
statusFreeFirstAsset: "لا رسوم حتى الآن. تبدأ الفوترة عندما تضيف أصولًا أكثر مما تتضمنه خطتك مجانًا.",
statusFreeLimitReached: "وصلت إلى حدك المجاني. اختر خطة لإضافة المزيد من الأصول.",
statusFreePeriodEnded: "انتهت فترتك المجانية وأصبحت مساحة العمل للقراءة فقط. اختر خطة لمواصلة العمل؛ لم يُحذف أي شيء.",
statusActive: "اشتراكك نشط.",
statusActiveRenews: "اشتراكك نشط ويتجدد في {{date}}.",
statusActiveEnds: "تم إلغاء اشتراكك وينتهي في {{date}}. تحتفظ بخطتك حتى ذلك الحين.",
statusBilledByStore: "يُفوتر اشتراكك عبر متجر التطبيقات. يمكنك إدارته هناك.",
changePlanHint: "انتقل إلى خطة أخرى؛ يتم تأكيد التغيير قبل أي خصم.",
cancelSubscription: "إلغاء الاشتراك",
cancelSubscriptionHint: "تبقى خطتك حتى نهاية الفترة المدفوعة؛ لن يُخصم أي مبلغ إضافي.",
resumeSubscription: "استئناف الاشتراك",
resumeSubscriptionHint: "احتفظ بخطتك؛ تتجدد كما كانت.",
cancelSubscriptionConfirmTitle: "إلغاء اشتراكك؟",
cancelSubscriptionConfirmBody: "تحتفظ بخطة {{plan}} حتى {{date}}؛ لن يُخصم أي مبلغ إضافي. يمكنك الاستئناف في أي وقت قبل ذلك.",
cancelSubscriptionConfirmBodyNoDate: "تحتفظ بخطة {{plan}} حتى نهاية الفترة الحالية؛ لن يُخصم أي مبلغ إضافي. يمكنك الاستئناف في أي وقت قبل ذلك.",
cancelSubscriptionKeep: "الاحتفاظ بخطتي",
cancelSubscriptionConfirm: "إلغاء الاشتراك",
cancelSubscriptionError: "تعذّر تغيير اشتراكك.",
planReference: "فوترة {{plan}}",
paymentStatusLabel: "حالة الدفع",
paymentStatusFreeDetail: "لا رسوم حتى الآن. تبدأ الفوترة عندما تضيف أصولًا أكثر مما تتضمنه خطتك مجانًا.",
paymentStatusGrantedDetail: "مقدَّمة دون رسوم. لا يُفوتَر أي شيء.",
paymentStatusSubscriptionRequiredDetail: "تم الوصول إلى الحد المجاني. ابدأ اشتراكًا للاستمرار في إضافة أصول نشطة.",
paymentStatusStripeDetail: "الفوترة نشطة لمساحة العمل هذه.",
paymentStatusPastDueDetail: "الدفعة متأخرة. عالجها في بوابة الفوترة لتجنب انقطاع الخدمة.",
paymentStatusPausedDetail: "الاشتراك متوقف مؤقتًا. استأنف الفوترة قبل إضافة أصول نشطة أخرى.",
paymentStatusInactiveDetail: "لا توجد عملية تحصيل نشطة. ابدأ أو استعد اشتراكًا لمتابعة الفوترة.",
paymentStatusInternalDetail: "لم يكتمل إعداد الفوترة لمساحة العمل هذه بعد، لذا هذه آخر حالة متوفرة لدينا.",
renewalDateLabel: "تاريخ التجديد",
renewalKnownDetail: "بناءً على آخر تاريخ انتهاء فترة اشتراك متزامن.",
renewalUnknownDetail: "توقيت التجديد غير متوفر حتى الآن لمساحة العمل هذه.",
lastTrueUpLabel: "آخر عدّ للأصول",
trueUpKnownDetail: "متى عُدّت أصولك النشطة آخر مرة لأغراض الفوترة.",
trueUpUnknownDetail: "لم تُعدّ أصولك لأغراض الفوترة بعد.",
presentmentCurrencyLabel: "عملة الفاتورة",
presentmentCurrencyBadge: "فوترة {{currency}}",
currencyUnknown: "غير معروفة",
currencyPresentmentNote: "تُحدَّد الأسعار بـ {{currency}}. قد تعرض فاتورتك عملتك المحلية.",
currencyCatalogOnlyNote: "الأسعار والفواتير بـ {{currency}}.",
editionTitle: "خطتك",
editionSubtitle: "تحدد خطتك الميزات المتاحة. تُفوتر الأصول وأرصدة الذكاء الاصطناعي بشكل منفصل.",
monthlyAmountTitle: "المبلغ الشهري المقدّر",
monthlyAmountSubtitle: "تعرض فاتورتك الإجمالي النهائي.",
amountFinal: "المبلغ النهائي",
amountEstimated: "المبلغ المقدّر",
amountUnavailable: "المبلغ غير متاح",
amountFinalExplanation: "من آخر فاتورة مسددة.",
amountEstimatedPresentmentExplanation: "مبلغ تقديري. تعرض فاتورتك المبلغ النهائي، وقد يكون بعملتك المحلية.",
amountEstimatedCatalogExplanation: "مبلغ تقديري بعملة {{currency}}. تعرض فاتورتك المبلغ النهائي.",
amountUnavailableExplanation: "لا يتوفر حتى الآن مبلغ موثوق موجّه للعميل.",
creditsAndAssetsTitle: "الأرصدة والأصول القابلة للفوترة",
creditsAndAssetsSubtitle: "الأرصدة التشغيلية للاستخدام والحدود.",
billableAssetsMetric: "الأصول النشطة القابلة للفوترة",
includedMonthlyMetric: "الأرصدة الشهرية المضمّنة",
purchasedCreditsMetric: "الأرصدة المشتراة",
totalRemainingCreditsMetric: "إجمالي الأرصدة المتبقية",
pricingExplanationTitle: "تفاصيل التسعير",
pricingExplanationSubtitle: "شرائح الفوترة الحالية من الكتالوج.",
pricingSummaryKnown: "تسعير متدرج لـ {{assetCount}} أصل نشط قابل للفوترة، مرجعه بعملة {{currency}}.",
pricingSummaryUnknown: "لا توجد شرائح تسعير منظّمة متاحة من كتالوج الفوترة حتى الآن، لذا لا يمكن لواجهة المستخدم تقديم شرح تسعير موثوق سطرًا بسطر.",
pricingBandOpenEnded: "{{min}}+ أصل",
pricingBandRange: "من {{min}} إلى {{max}} أصل",
pricingBandLabel: "{{label}}",
pricingBandUnknown: "السعر غير متاح",
pricingBandEmpty: "لم يتم تكوين شرائح تسعير لنموذج الفوترة هذا حتى الآن.",
catalogReferenceNote: "عملة المرجع في الكتالوج: {{currency}}.",
startSubscription: "بدء الاشتراك",
startSubscriptionHint: "ابدأ اشتراكًا لإضافة أصول أكثر مما تتضمنه خطتك مجانًا.",
startSubscriptionAdminOnly: "لا يستطيع بدء الاشتراك إلا مالك مساحة العمل.",
startSubscriptionStripeOff: "الشراء غير متاح حاليًا.",
startSubscriptionUnavailable: "لا يمكن لمساحة العمل هذه بدء اشتراك جديد من حالة الفوترة الحالية.",
manageSubscriptionHint: "افتح بوابة الفوترة لإدارة اشتراكك أو طريقة الدفع.",
manageBillingAdminOnly: "لا يستطيع إدارة الفوترة إلا مالك مساحة العمل.",
manageBillingUnavailable: "الوصول إلى بوابة الفوترة غير متاح لمساحة العمل هذه حتى الآن.",
buyMoreCredits: "شراء أرصدة",
buyCreditsHint: "اشترِ باقة أرصدة. دفع آمن لمرة واحدة.",
buyCreditsAdminOnly: "لا يستطيع شراء الأرصدة إلا مالك مساحة العمل.",
buyCreditsStripeOff: "الشراء غير متاح حاليًا.",
buyCreditsUnavailable: "لم يتم تكوين سعر باقة الأرصدة حتى الآن.",
buyCreditsPriceHint: "سعر المرجع في الكتالوج: {{price}}.",
priceUnavailable: "السعر غير متاح",
activityTitle: "نشاط الأرصدة الأخير",
activitySubtitle: "أحدث حركات الأرصدة (معاينة).",
subscriptionDetailsTitle: "تفاصيل الاشتراك",
subscriptionDetailsSubtitle: "تفاصيل التوقيت التشغيلي والمزامنة.",
currencyDetailsTitle: "تفاصيل العملة",
currencyDetailsSubtitle: "سلوك عملة العرض والكتالوج.",
showDetails: "إظهار التفاصيل",
hideDetails: "إخفاء التفاصيل",
ledgerEmpty: "لا يوجد نشاط للأرصدة بعد.",
linkAudit: "فتح تدقيق الذكاء الاصطناعي والأتمتة",
manageStripeBilling: "إدارة الاشتراك",
stripeCheckoutError: "تعذّر فتح صفحة الدفع. حاول مرة أخرى.",
stripePortalError: "تعذّر فتح إدارة الفوترة. حاول مرة أخرى.",
stripeConfigOff: "الدفع عبر Stripe معطّل. في ملف `.env` بجذر المشروع، اضبط EXPO_PUBLIC_STRIPE_BILLING_ENABLED=true، ثم أضف EXPO_PUBLIC_STRIPE_PRICE_ID_ASSET_SUBSCRIPTION و/أو EXPO_PUBLIC_STRIPE_PRICE_ID_CREDIT_PACK_100 (يجب أن يكون كل منها معرّف Stripe من نوع price_...). أعد تشغيل Expo باستخدام `npx expo start --clear`.",
stripeConfigNoPrices: "تم تفعيل Stripe ولكن لم يتم العثور على معرّفات أسعار صالحة. استخدم معرّفات أسعار Stripe التي تبدأ بـ `price_` (وليس `prod_`). اضبط EXPO_PUBLIC_STRIPE_PRICE_ID_ASSET_SUBSCRIPTION و/أو EXPO_PUBLIC_STRIPE_PRICE_ID_CREDIT_PACK_100 في `.env`، ثم أعد تشغيل Expo.",
confirmationConfirmedTitle: "اكتمل الشراء",
confirmationCancelledTitle: "تم إلغاء الدفع",
confirmationPendingTitle: "جارٍ إتمام عملية الشراء",
confirmationConfirmedBody: "تم. خطتك وأرصدتك أدناه محدثة.",
confirmationCancelledBody: "لم يُطبَّق أي تغيير في الفوترة. خطتك الحالية وأرصدتك لم تتغير.",
confirmationPendingBody: "تم استلام الدفع. ستُحدَّث خطتك وأرصدتك خلال ثوانٍ. اضغط تحديث إن لم يحدث ذلك.",
trialCapBody_one: "تسمح فترتك التجريبية بـ {{max}}. لديك {{billable}} أصول نشطة، لذا ستبدأ فوترة أصل واحد عندما تصبح فترتك التجريبية خطة مدفوعة.",
trialCapBody_other: "تسمح فترتك التجريبية بـ {{max}}. لديك {{billable}} أصول نشطة، لذا ستبدأ فوترة {{count}} أصل عندما تصبح فترتك التجريبية خطة مدفوعة.",
trialCapBodyDated_one: "تسمح فترتك التجريبية بـ {{max}}. لديك {{billable}} أصول نشطة، لذا ستبدأ فوترة أصل واحد عند انتهاء فترتك التجريبية في {{trialEnd}}.",
trialCapBodyDated_other: "تسمح فترتك التجريبية بـ {{max}}. لديك {{billable}} أصول نشطة، لذا ستبدأ فوترة {{count}} أصل عند انتهاء فترتك التجريبية في {{trialEnd}}.",
forecastTitle: "استهلاك أرصدة الذكاء الاصطناعي والتوقعات",
forecastSubtitle: "كيف استُخدمت أرصدتك خلال الثلاثين يومًا الماضية، وإلى متى ستكفي.",
consumedLast30Days: "المستهلك خلال 30 يومًا",
averageDailyUse: "المتوسط اليومي",
estimatedRunway: "تكفي الأرصدة نحو",
runwayNotLimited: "غير محدود",
runwayDays_one: "يوم واحد",
runwayDays_other: "{{count}} يوم",
ledgerReconciled: "الرصيد محدث",
ledgerPartial: "الرصيد قيد التحديث",
contactAdminTitle: "يدير مالك مساحة العمل الفوترة",
contactAdminTitleNamed: "يدير مالك {{workspace}} الخطة والأرصدة",
contactAdminSubtitle: "يمكنك رؤية الاستخدام هنا. لا يستطيع تغيير الخطة أو شراء الأرصدة إلا المالك.",
viewWorkspaceAdmins: "عرض مسؤولي مساحة العمل",
detailsTitle: "تفاصيل الفوترة",
detailsSubtitle: "الاشتراك والأسعار والعملة.",
chargingPolicyTitle: "كيف تُحتسب أرصدة الذكاء الاصطناعي",
chargingPolicySubtitle: "ما تدفع مقابله، وما لا تدفع مقابله، وما يحدث إذا فشل شيء.",
chargingSuccess: "تُحاسب مرة واحدة على الذكاء الاصطناعي الذي ينجح، بعد حصولك على النتيجة.",
chargingFailure: "لا يُحتسب ناتج الذكاء الاصطناعي الفاشل، ويبقى العمل اليدوي متاحًا.",
chargingRetry: "إذا فشل تسجيل الخصم، نعيد المحاولة مرة واحدة ولا نخصم مرتين أبدًا.",
packForecastNoPattern: "يظهر أثر التوقعات بعد تسجيل الاستهلاك.",
packForecastDays_one: "نحو يوم إضافي واحد بمعدل الاستهلاك الحالي",
packForecastDays_other: "نحو {{count}} يوم إضافي بمعدل الاستهلاك الحالي",
trialCapBody_zero: "تسمح فترتك التجريبية بـ {{max}}. لديك {{billable}} أصول نشطة، فلن يُفوتر أي أصل إضافي عندما تصبح فترتك التجريبية خطة مدفوعة.",
trialCapBody_two: "تسمح فترتك التجريبية بـ {{max}}. لديك {{billable}} أصول نشطة، لذا ستبدأ فوترة أصلين عندما تصبح فترتك التجريبية خطة مدفوعة.",
trialCapBody_few: "تسمح فترتك التجريبية بـ {{max}}. لديك {{billable}} أصول نشطة، لذا ستبدأ فوترة {{count}} أصول عندما تصبح فترتك التجريبية خطة مدفوعة.",
trialCapBody_many: "تسمح فترتك التجريبية بـ {{max}}. لديك {{billable}} أصول نشطة، لذا ستبدأ فوترة {{count}} أصلًا عندما تصبح فترتك التجريبية خطة مدفوعة.",
trialCapBodyDated_zero: "تسمح فترتك التجريبية بـ {{max}}. لديك {{billable}} أصول نشطة، فلن يُفوتر أي أصل إضافي عند انتهاء فترتك التجريبية في {{trialEnd}}.",
trialCapBodyDated_two: "تسمح فترتك التجريبية بـ {{max}}. لديك {{billable}} أصول نشطة، لذا ستبدأ فوترة أصلين عند انتهاء فترتك التجريبية في {{trialEnd}}.",
trialCapBodyDated_few: "تسمح فترتك التجريبية بـ {{max}}. لديك {{billable}} أصول نشطة، لذا ستبدأ فوترة {{count}} أصول عند انتهاء فترتك التجريبية في {{trialEnd}}.",
trialCapBodyDated_many: "تسمح فترتك التجريبية بـ {{max}}. لديك {{billable}} أصول نشطة، لذا ستبدأ فوترة {{count}} أصلًا عند انتهاء فترتك التجريبية في {{trialEnd}}.",
runwayDays_zero: "لا أيام",
runwayDays_two: "يومان",
runwayDays_few: "{{count}} أيام",
runwayDays_many: "{{count}} يومًا",
packForecastDays_zero: "لا أيام إضافية بمعدل الاستهلاك الحالي",
packForecastDays_two: "نحو يومين إضافيين بمعدل الاستهلاك الحالي",
packForecastDays_few: "نحو {{count}} أيام إضافية بمعدل الاستهلاك الحالي",
packForecastDays_many: "نحو {{count}} يومًا إضافيًا بمعدل الاستهلاك الحالي",
},
};
